import type { IconAliases } from 'vuetify';

const aliases: IconAliases = {
  complete: 'fal fa-check',
  cancel: 'fal fa-times-circle',
  close: 'fal fa-times',
  delete: 'fal fa-times-circle', // delete (e.g. v-chip close),
  clear: 'fal fa-times-circle', // delete (e.g. v-chip close),
  success: 'fal fa-check-circle',
  info: 'fal fa-info-circle',
  warning: 'fal fa-exclamation',
  error: 'fal fa-exclamation-triangle',
  prev: 'fal fa-chevron-left',
  next: 'fal fa-chevron-right',
  checkboxOn: 'fal fa-check-square',
  checkboxOff: 'far fa-square',
  checkboxIndeterminate: 'fal fa-minus-square',
  delimiter: 'fal fa-circle',
  sortAsc: 'fal fa-sort-down',
  sortDesc: 'fal fa-sort-up',
  expand: 'fal fa-chevron-down',
  menu: 'fal fa-bars',
  subgroup: 'fal fa-caret-down',
  dropdown: 'fal fa-caret-down',
  radioOn: 'far fa-dot-circle',
  radioOff: 'far fa-circle',
  edit: 'fal fa-edit',
  ratingEmpty: 'far fa-star',
  ratingFull: 'fal fa-star',
  ratingHalf: 'fal fa-star-half',
  loading: 'fal fa-sync',
  first: 'fal fa-step-backward',
  last: 'fal fa-step-forward',
  unfold: 'fal fa-arrows-alt-v',
  file: 'fal fa-paperclip',
  plus: 'fal fa-plus',
  minus: 'fal fa-minus',
  calendar: 'fal-calendar',
  collapse: 'fal fa-chevron-up',
  treeviewCollapse: 'fal fa-chevron-up',
  treeviewExpand: 'fal fa-chevron-down',
  eyeDropper: 'fal fa-eye-dropper',
  upload: 'fal fa-upload',
  color: 'fal fa-palette',
  command: 'fal fa-command',
  ctrl: 'fal fa-control',
  space: 'fal fa-space-shuttle',
  shift: 'fal fa-shift',
  alt: 'fal fa-alt',
  enter: 'fal fa-level-down-alt',
  arrowup: 'fal fa-arrow-up',
  arrowdown: 'fal fa-arrow-down',
  arrowleft: 'fal fa-arrow-left',
  arrowright: 'fal fa-arrow-right',
  backspace: 'fal fa-backspace',
};

export default aliases;
